// routes/FrontendRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import TechnologyLandscape from '../components/Frontend/AccountDetails/TechnolgyLandscape/TechnologyLandscape';

export const technologyLandscapeRoutes = (
  <>
    <Route path="account_details/technology_landscape" element={<MainLayout />}>
      <Route index element={<TechnologyLandscape />} />
    </Route>
  </>
);
